export default "__VITE_ASSET__Bp6g0YHF__"